import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Card from '../../../../components/Card'
import BannerImage from '../../../../components/BannerImage'

interface Props {
  team: wowaudit.TeamReference
  continueSetup?: boolean
}

const TeamCard = ({ team, continueSetup = false }: Props) => {
  const resuming = continueSetup && !!team.onboardingStep
  const to = resuming
    ? `${team.ownerReference.path}/onboarding?step=${team.onboardingStep}&team=${team.id}`
    : team.path

  return (
    <Link to={to} className='group block'>
      <Card className='flex w-full items-center gap-2 p-2 transition-colors group-hover:border-primary/40'>
        <BannerImage
          size='small'
          faction={team.ownerReference.faction}
          fileName={team.ownerReference.bannerFilename}
          className='shrink-0 rounded-md'
        />
        <div className='flex min-w-0 flex-col'>
          <span className='truncate text-sm font-medium'>
            {team.ownerReference.name}
          </span>
          <span className='truncate text-xs text-muted-foreground'>
            {team.name}
          </span>
          {resuming ? (
            <span className='truncate text-xs text-info-foreground'>
              Continue setup
            </span>
          ) : null}
        </div>
        <ArrowRight className='ml-auto h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary' />
      </Card>
    </Link>
  )
}

export default TeamCard
